import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { css } from "styled-components";

categoriesStyles.categoryNameLink = {
    typographyProps: {
        weight: "normal",
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    color: "text.main",
    css: css`
        width: 100%;
    `,
}